import {Validators} from '@angular/forms';

// Matches the API IdentityPassword policy for newly chosen passwords.
export const sharedPasswordValidator = Validators.compose([
  Validators.required,
  Validators.minLength(10),
  Validators.pattern(/^(?=[\s\S]*[a-z])(?=[\s\S]*[A-Z])(?=[\s\S]*[0-9])[\s\S]*$/),
]);
